import React, { useEffect } from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import { rating as ratingData } from '../../../../constants/copyright';
import { useTranslation } from '../../../../translations';
import { getDaysDeclension } from '../../../../utils/helpers/helpers';
import { useCountdownToSundayMSK } from '../../../../hooks/useCountdownToSundayMSK';
import { useApplicationCallbacks } from '../../../../providers/application-callbacks';

const { countDownText } = ratingData;

export default function RatingCountDown() {
  const { t } = useTranslation();
  const callbacks = useApplicationCallbacks();

  const { days, hours, minutes, seconds, diffTime } = useCountdownToSundayMSK(1000);

  const formattedText = () => {
    return days > 0
      ? `<strong>${days} ${t(getDaysDeclension(days))}</strong>`
      : `<strong>${hours}:${minutes}:${seconds}</strong>`;
  };

  useEffect(() => {
    // Когда таймер подходит к концу обновляем данные рейтинга
    if (diffTime && diffTime <= 1000) {
      callbacks.getGeneralRating();
    }
  }, [diffTime]);

  return (
    <div className={'rating__count-down'}>
      <span>{safeHTML(t(countDownText, { time: formattedText() }))}</span>
    </div>
  );
}
